import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Guard, mappingResultError, Result, UniqueEntityID, UseCase } from '@digibricks/core';
import { MatchingCorrectAnswer, Score, SubMatchingQuestion } from '../../../domain';
export var CREATE_SUB_QUESTION_CORRECT_ANSWER_USE_CASE = 'CREATE_SUB_QUESTION_CORRECT_ANSWER_USE_CASE';
export var CreateSubQuestionAndCorrectAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateSubQuestionAndCorrectAnswerUseCase, _UseCase);

  var _super = _createSuper(CreateSubQuestionAndCorrectAnswerUseCase);

  function CreateSubQuestionAndCorrectAnswerUseCase() {
    _classCallCheck(this, CreateSubQuestionAndCorrectAnswerUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(CreateSubQuestionAndCorrectAnswerUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var currentQuestion, data, guardCollection, guardResult, description, index, subQuestionResult, correctAnswerResult, updatedCurrentQuestion, updatedResult, totalScore;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, data = input.data;
                guardCollection = [{
                  argument: currentQuestion,
                  argumentName: 'Current Question'
                }, {
                  argument: data,
                  argumentName: 'Data input'
                }];
                guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

                if (guardResult.succeeded) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", new BadInputError(guardResult.message));

              case 5:
                description = data.description, index = data.index;
                subQuestionResult = SubMatchingQuestion.create({
                  id: new UniqueEntityID().toString(),
                  description: description,
                  index: index
                });

                if (!subQuestionResult.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", mappingResultError(subQuestionResult));

              case 9:
                correctAnswerResult = MatchingCorrectAnswer.create({
                  answerId: currentQuestion.answers && currentQuestion.answers[0].id.toString(),
                  subQuestionId: subQuestionResult.getValue().id.toString(),
                  score: Score["default"],
                  index: subQuestionResult.getValue().index
                });

                if (!correctAnswerResult.isFailure) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", mappingResultError(correctAnswerResult));

              case 12:
                updatedCurrentQuestion = currentQuestion.addNewCorrectAnswer(correctAnswerResult.getValue());

                if (!updatedCurrentQuestion.isFailure) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", mappingResultError(correctAnswerResult));

              case 15:
                updatedResult = currentQuestion.addSubQuestion(subQuestionResult.getValue());

                if (!updatedResult.isFailure) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", mappingResultError(subQuestionResult));

              case 18:
                totalScore = currentQuestion.correctAnswers.reduce(function (a, b) {
                  return a + b.score;
                }, 0);
                currentQuestion.updateScore(totalScore);
                return _context.abrupt("return", Result.ok(currentQuestion));

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreateSubQuestionAndCorrectAnswerUseCase;
}(UseCase);